import React from 'react';
import { Handle, Position } from 'reactflow';

export default function StreakNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #be123c',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#fb7185' }}>
        📉 Streak / Drawdown
      </div>

      <select
        value={data.measure || 'drawdown_pct'}
        onChange={(e) => onChange('measure', e.target.value)}
        style={{ width: '100%', padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
      >
        <option value="drawdown_pct">Drawdown % (from equity peak)</option>
        <option value="win_streak">Consecutive Wins</option>
        <option value="loss_streak">Consecutive Losses</option>
      </select>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Reflects this strategy's own simulated trade history, not price. Useful for risk control, e.g. "pause new entries after 3 consecutive losses."
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#be123c' }} />
    </div>
  );
}
